const FONT_FAMILY = '"Plus Jakarta Sans", sans-serif';
const CARD_RADIUS = "12px";
const CARD_SHADOW = "0 10px 35px rgba(0,0,0,0.08)";
const PRIMARY_COLOR = "#EB0000";
const DANGER_COLOR = "#D92D20";
const TEXT_COLOR = "#344555";
const BORDER_COLOR = "#D1D5DB";
const SELECTED_BORDER_COLOR = "#111827";
const SELECTED_BACKGROUND = "#F9FAFB";
const RADIO_SELECTED_COLOR = "#1C7B3E";

const fullWidthColumn = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
};

export const pageContent = {
  ...fullWidthColumn,
  fontFamily: FONT_FAMILY,
  padding: 0,
};

export const tableCard = {
  ...fullWidthColumn,
  fontFamily: FONT_FAMILY,
  padding: "20px",
  borderRadius: CARD_RADIUS,
  boxShadow: CARD_SHADOW,
  backgroundColor: "#FFFFFF",
};

export const toolbar = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "12px",
  marginBottom: "20px",
  flexWrap: "wrap",
};

export const searchActions = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "20px",
  flexWrap: "wrap",
};

export const searchInput = {
  width: "320px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
  },
  "& .MuiInputBase-root, & .MuiInputBase-input": {
    fontFamily: FONT_FAMILY,
  },
};

export const clearButton = {
  height: "40px",
  padding: "12px",
  border: "none",
  color: "#15202A",
  fontFamily: FONT_FAMILY,
  fontSize: "12px",
  fontWeight: 700,
  textTransform: "none",
  "&:hover": {
    border: "none",
    backgroundColor: "transparent",
  },
};

export const createUserButton = {
  height: "40px",
  padding: "12px",
  border: "none",
  borderRadius: "8px",
  backgroundColor: PRIMARY_COLOR,
  color: "#FFFFFF",
  fontFamily: FONT_FAMILY,
  fontSize: "12px",
  fontWeight: 700,
  textTransform: "none",
  "&:hover": {
    border: "none",
    backgroundColor: "#D50000",
  },
};

export const editActionIcon = {
  fontSize: 18,
  marginRight: 1.2,
  color: TEXT_COLOR,
};

export const deleteActionItem = {
  color: DANGER_COLOR,
};

export const deleteActionIcon = {
  fontSize: 18,
  marginRight: 1.2,
};

export const dialogPaper = {
  borderRadius: "18px",
  overflow: "visible",
};

export const dialogTitle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  fontSize: "22px",
  fontWeight: 700,
  color: TEXT_COLOR,
};

export const dialogCloseButton = (submitting) => ({
  cursor: submitting ? "not-allowed" : "pointer",
  fontSize: "22px",
  opacity: submitting ? 0.5 : 1,
  "&:hover": {
    opacity: submitting ? 0.5 : 0.7,
  },
});

export const requiredLabel = {
  display: "flex",
  alignItems: "center",
  gap: 0.4,
  marginBottom: 1,
};

export const requiredMark = {
  color: DANGER_COLOR,
  fontWeight: 700,
};

export const optionCard = (selected) => ({
  cursor: "pointer",
  border: "2px solid",
  borderColor: selected ? SELECTED_BORDER_COLOR : BORDER_COLOR,
  borderRadius: "12px",
  padding: "18px 16px",
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  background: selected ? SELECTED_BACKGROUND : "#FFFFFF",
  "&:hover": {
    borderColor: SELECTED_BORDER_COLOR,
  },
});

export const optionRadio = (selected) => ({
  width: 22,
  height: 22,
  borderRadius: "50%",
  border: "2px solid",
  borderColor: selected ? RADIO_SELECTED_COLOR : "#9CA3AF",
  display: "grid",
  placeItems: "center",
});

export const optionRadioDot = {
  width: 10,
  height: 10,
  borderRadius: "50%",
  background: RADIO_SELECTED_COLOR,
};

export const roundedInput = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
  },
};

export const passwordToggle = (submitting) => ({
  cursor: submitting ? "not-allowed" : "pointer",
});

export const dialogActions = {
  paddingLeft: 3,
  paddingRight: 3,
  paddingBottom: 3,
  paddingTop: 2,
  display: "flex",
  justifyContent: "space-between",
};

export const dialogActionButton = {
  paddingLeft: 4,
  paddingRight: 4,
  paddingTop: 1.4,
  paddingBottom: 1.4,
};
